export const multiSelectConfigs = {
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? 0 : 0,
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        '&:hover': {
            border: state.isFocused ? 0 : 0,
        },
    }),
    multiValue: (base, state) => {
        return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
    },
    multiValueLabel: (base, state) => {
        return state.data.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
    },
    multiValueRemove: (base, state) => {
        return state.data.isFixed ? { ...base, display: 'none' } : base;
    },
};

export const resourcesIds = (data) => {
    const result = [];
    data.forEach((row) => {
        result.push(row.value);
    });

    return result;
};

export const listOfResources = (resourcesArray, fixedId = null) => {
    if (resourcesArray !== null) {
        return resourcesArray.map((item) => {
            const result = {
                value: item.id,
                label: item.name,
            };

            if (fixedId) {
                result.isFixed = parseInt(item.id) === parseInt(fixedId);
            }

            return result;
        });
    }

    return [];
};

export const prepareRelationsData = (rolesData, departmentsData, venuesData, costcentersData, revDepartmentsData, revCostcentersData, modulesData = []) => {
    const rolesIds = resourcesIds(rolesData);
    const departmentsIds = resourcesIds(departmentsData);
    const venuesIds = resourcesIds(venuesData);
    const costcentersIds = resourcesIds(costcentersData);
    const revdepartmentsIds = resourcesIds(revDepartmentsData);
    const revcostcentersIds = resourcesIds(revCostcentersData);
    const modulesIds = resourcesIds(modulesData);

    return {
        rolesIds,
        departmentsIds,
        venuesIds,
        costcentersIds,
        revdepartmentsIds,
        revcostcentersIds,
        modulesIds,
    };
};

export const onChangeUserAssociations = (e, option, handler) => {
    const result = e;
    if (option.removedValues && option.removedValues.length) {
        option.removedValues.forEach((val) => {
            if (val.isFixed) {
                result.push(val);
            }
        });
    }
    handler(result);
};
